/* ==========================================================================
   SACOLA EM GAVETA (AJAX)
   ⚠️ O CARRINHO NUNCA VIRA PAGINA (regra do JM): todo link para /cart abre a
   gaveta. A pagina /cart continua existindo para quem chega por link direto
   ou com o JS fora do ar.

   Quem calcula preco, desconto e total e a LOJA: depois de cada mudanca a
   gaveta inteira e redesenhada pelo servidor (Section Rendering API), em vez
   de o navegador somar por conta propria e divergir do checkout.
   1.3.11: a gaveta também leva a classe "active" quando aberta - é o que o
   Releasit observa para recolocar o botão de pagar ao receber depois que o
   servidor redesenha a gaveta.
   ========================================================================== */
BV.quandoPronto(function (loja) {
  const sacola = document.getElementById('sacola');
  if (!sacola) return;

  let voltarPara = null;

  function abre() {
    voltarPara = document.activeElement;
    sacola.hidden = false;
    void sacola.offsetHeight;
    sacola.classList.add('aberta', 'active');
    document.documentElement.classList.add('sem-rolagem');
    const fechar = sacola.querySelector('.sacola__fechar');
    if (fechar) fechar.focus({ preventScroll: true });
  }
  function fecha() {
    sacola.classList.remove('aberta', 'active');
    document.documentElement.classList.remove('sem-rolagem');
    setTimeout(() => { sacola.hidden = true; }, 260);
    if (voltarPara && voltarPara.focus) voltarPara.focus({ preventScroll: true });
  }

  /* Redesenha a gaveta com o HTML que o servidor acabou de gerar. */
  function redesenha() {
    return fetch('?sections=sacola')
      .then(r => r.json())
      .then(function (d) {
        const html = d['sacola'];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nova = doc.getElementById('sacola');
        if (!nova) return;
        const aberta = sacola.classList.contains('aberta');
        sacola.innerHTML = nova.innerHTML;
        if (aberta) sacola.classList.add('aberta', 'active');
        const conta = document.getElementById('cesta-conta');
        const novaConta = doc.getElementById('sacola-conta');
        if (conta && novaConta) {
          const n = (novaConta.textContent.match(/\d+/) || [0])[0];
          conta.textContent = n;
        }
      });
  }

  function adiciona(id, quantidade) {
    return fetch(loja.adicionar || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: quantidade || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(e => { throw new Error(e.description || 'erro'); });
      return r.json();
    }).then(function () {
      return redesenha();
    }).then(function () {
      abre();
    });
  }

  function muda(chave, quantidade) {
    return fetch(loja.mudar || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: chave, quantity: quantidade })
    }).then(() => redesenha());
  }

  /* --- gatilhos ---------------------------------------------------------- */
  document.addEventListener('click', function (ev) {
    /* Qualquer link para o carrinho abre a gaveta. */
    const link = ev.target.closest('a[href$="/cart"], a[href*="/cart?"], [data-abre-sacola]');
    if (link) { ev.preventDefault(); abre(); return; }

    /* "Anadir" do cartao, dos recomendados e da barra fixa. */
    const add = ev.target.closest('[data-add-variante]');
    if (add) {
      ev.preventDefault();
      add.classList.add('ocupado');
      const qtdCampo = document.getElementById('pdp-qtd');
      const qtd = add.classList.contains('pdpbarra__botao') && qtdCampo ? Number(qtdCampo.value) || 1 : 1;
      adiciona(Number(add.dataset.addVariante), qtd)
        .catch(() => { window.location.href = loja.carrinho || '/cart'; })
        .then(() => add.classList.remove('ocupado'));
      return;
    }

    if (ev.target.closest('[data-fecha-sacola]')) { fecha(); return; }

    const linha = ev.target.closest('.sacola__linha');
    if (!linha) return;
    const chave = linha.dataset.chave;
    const campo = linha.querySelector('[data-qtd]');
    if (ev.target.closest('[data-tirar]')) { muda(chave, 0); return; }
    if (ev.target.closest('[data-menos]')) { muda(chave, Math.max(0, Number(campo.value) - 1)); return; }
    if (ev.target.closest('[data-mais]')) { muda(chave, Number(campo.value) + 1); return; }
  });

  sacola.addEventListener('change', function (ev) {
    const campo = ev.target.closest('[data-qtd]');
    if (!campo) return;
    const linha = campo.closest('.sacola__linha');
    muda(linha.dataset.chave, Math.max(0, Number(campo.value)));
  });

  document.addEventListener('keydown', ev => { if (ev.key === 'Escape' && !sacola.hidden) fecha(); });

  /* O formulario da pagina de produto tambem entra pela gaveta. */
  const form = document.getElementById('form-produto');
  if (form) form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    const id = Number(form.querySelector('[name="id"]').value);
    const qtd = Number((form.querySelector('[name="quantity"]') || {}).value || 1);
    const botao = form.querySelector('.pdp__add');
    if (botao) botao.classList.add('ocupado');
    adiciona(id, qtd)
      .catch(() => form.submit())
      .then(() => { if (botao) botao.classList.remove('ocupado'); });
  });

  BV.sacola = { abre: abre, fecha: fecha, adiciona: adiciona, redesenha: redesenha };
});
